import {useLocation} from "react-router";

import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";

export function usePageLinkBuilder() {
    const location = useLocation();

    return (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };
}
